import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { Input, InputAlert } from '@creditornot/cb-input';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { WHOLE_NUMBER_PATTERN } from 'common/utils/numberUtils';

import { FormValues } from './types';

const StyledInputAlert = styled(InputAlert)`
  margin-top: 8px;
  width: 100%;
`;

type Props = {
  expectedQuantity?: number;
  onClick?: () => void;
};

const QuantityField = ({ expectedQuantity, onClick }: Props) => {
  const formatMessage = useFormatMessage();
  const { watch } = useFormContext<FormValues>();
  const inputQuantityValue = watch('quantity');
  return (
    <Controller
      name="quantity"
      rules={{
        required: formatMessage('common.validation.required'),
        min: {
          message: formatMessage('common.validation.min', { min: 1 }),
          value: 1,
        },
        max: {
          message: formatMessage('common.validation.less_than', { lessThan: 1000 }),
          value: 999,
        },
        pattern: {
          value: WHOLE_NUMBER_PATTERN,
          message: formatMessage('common.validation.whole_number'),
        },
      }}
      render={({ fieldState: { error }, field: { onChange, value } }) => (
        <>
          <Input
            pattern="[0-9]*"
            inputMode="numeric"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            autoFocus={true}
            data-test-id="item-increase-quantity"
            invalid={!!error}
            onClick={onClick}
          />
          {error && <StyledInputAlert variant="error">{error.message}</StyledInputAlert>}
          {expectedQuantity !== undefined && parseInt(inputQuantityValue) > expectedQuantity && (
            <StyledInputAlert variant="warning">
              {formatMessage('receiving.input_quantity_exceeds_expected_quantity')}
            </StyledInputAlert>
          )}
        </>
      )}
    />
  );
};

export default QuantityField;
